import { useEffect, useState } from "react";
import api from "../lib/api";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">History</div>
        <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter">Audit log</h1>
        <p className="text-sm text-slate-500 mt-2">Every meaningful change to your portfolio, in order.</p>
      </div>
      <div className="bg-white border border-slate-200">
        {logs.length === 0 ? (
          <div className="p-12 text-center text-slate-500 flex flex-col items-center gap-2">
            <ScrollText className="h-8 w-8 text-slate-300" /> No activity yet.
          </div>
        ) : (
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
                <th className="px-6 py-3">When</th>
                <th className="px-6 py-3">Action</th>
                <th className="px-6 py-3">Entity</th>
                <th className="px-6 py-3">Detail</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-6 py-3 font-mono text-xs text-slate-600">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-6 py-3">
                    <span className="bg-slate-100 px-2 py-0.5 text-xs uppercase tracking-wider">{l.action}</span>
                  </td>
                  <td className="px-6 py-3 text-sm">{l.entity}</td>
                  <td className="px-6 py-3 text-xs font-mono text-slate-500">{JSON.stringify(l.meta)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
